import { QueryVariables } from '../../types';
import { INSTAGRAM_SEARCH_PARAMS } from '../types';

export const generateInstagramSearchParams = (
  params: Partial<QueryVariables>,
  currentSearchParams?: URLSearchParams,
): URLSearchParams => {
  const urlParams = new URLSearchParams();

  if (params.query && params.query.trim() !== '') {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.QUERY, params.query);
  }

  if (params.username && params.username.trim() !== '') {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.USERNAME, params.username);
  }

  if (params.creatorUsername && params.creatorUsername.trim() !== '') {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.CREATOR_USERNAME, params.creatorUsername);
  }

  if (params.ageBuckets && params.ageBuckets.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.AGE_BUCKETS, params.ageBuckets.join(','));
  }

  if (params.genders && params.genders.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.GENDERS, params.genders.join(','));
  }

  if (params.countries && params.countries.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.COUNTRIES, params.countries.join(','));
  }

  if (params.interests && params.interests.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.INTERESTS, params.interests.join(','));
  }

  if (params.minFollowers && params.minFollowers !== 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.MIN_FOLLOWERS, params.minFollowers.toString());
  }

  if (params.maxFollowers && params.maxFollowers !== 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.MAX_FOLLOWERS, params.maxFollowers.toString());
  }

  if (params.minEngagements && params.minEngagements !== 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.MIN_ENGAGEMENTS, params.minEngagements.toString());
  }

  if (params.maxEngagements && params.maxEngagements !== 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.MAX_ENGAGEMENTS, params.maxEngagements.toString());
  }

  if (params.majorAudienceAgeBuckets && params.majorAudienceAgeBuckets.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.MAJOR_AUDIENCE_AGE_BUCKETS, params.majorAudienceAgeBuckets.join(','));
  }

  if (params.majorAudienceGenders && params.majorAudienceGenders.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.MAJOR_AUDIENCE_GENDERS, params.majorAudienceGenders.join(','));
  }

  if (params.majorAudienceCountries && params.majorAudienceCountries.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.MAJOR_AUDIENCE_COUNTRIES, params.majorAudienceCountries.join(','));
  }

  if (params.similarToCreators && params.similarToCreators.length > 0) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.SIMILAR_TO_CREATORS, params.similarToCreators.join(','));
  }

  if (params.requireInCreatorMarketplace === true) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.REQUIRE_IN_CREATOR_MARKETPLACE, 'true');
  }

  if (params.searchContext) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.SEARCH_CONTEXT, params.searchContext);
  }

  if (params.before) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.BEFORE, params.before);
  }

  if (params.after) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.AFTER, params.after);
  }

  if (params.limit) {
    urlParams.set(INSTAGRAM_SEARCH_PARAMS.LIMIT, params.limit.toString());
  } else if (currentSearchParams?.has(INSTAGRAM_SEARCH_PARAMS.LIMIT)) {
    // Preserve existing limit if not explicitly set in params
    const existingLimit = currentSearchParams.get(INSTAGRAM_SEARCH_PARAMS.LIMIT);
    if (existingLimit) {
      urlParams.set(INSTAGRAM_SEARCH_PARAMS.LIMIT, existingLimit);
    }
  }

  if (currentSearchParams) {
    const managedParams = Object.values(INSTAGRAM_SEARCH_PARAMS);
    for (const [key, value] of currentSearchParams.entries()) {
      if (!managedParams.includes(key as (typeof managedParams)[number])) {
        urlParams.set(key, value);
      }
    }
  }

  return urlParams;
};
